var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-wrap",attrs:{"id":"bannerBox"}},[_c('div',{staticClass:"banner-bg"},[_c('canvas',{staticClass:"canvas-box",attrs:{"id":"canvas"}}),_c('div',{staticClass:"banner-bg-cover",class:'banner-bg-' + (_vm.navIndex)}),_c('div',{staticClass:"show-box"},[_c('navigation',{attrs:{"navIndex":_vm.navIndex}}),_vm._t("banner")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }